import { Autocomplete, Button, Paper, Text, Box, Flex, Group } from '@mantine/core'
import classes from './ManageCustomer.module.css';
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";

import React, { memo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TableCustomersComponent from './TableCustomers.component';
import InputButton from '../../../CustomComponent/InputFileButton/Inputbutton.component';
import { baseUrl } from '../../../Constants/constant';

const ManageCustomer = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [sendsearch, setSendsearch] = useState('');

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500); // Debounce input for better performance

    return () => clearTimeout(timeout); // Cleanup on re-renders
  }, [search]);

  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
          <Flex
            style={{ justifyContent: 'space-between' }}
            align="center" >
            <Box>
              <Text ta="left">Customers</Text>
            </Box>
            <Group >
              <Autocomplete
                // label="Your favorite library"
                value={search}
                onChange={handlechange}
                placeholder="Search by Customer name"
                leftSection={<IoMdSearch />}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/manage-customers/addcustomers')}
              >
                Add Customers
              </Button>
              <InputButton
                url={`${baseUrl}null`}
              // url={`${baseUrl}admin/customers/import-file`}
              />
            </Group>
          </Flex>
          <TableCustomersComponent editLink={'/manage-customers/addcustomers'} search={sendsearch} />
        </Box>
      </Paper>
    </>
  )
}

export default memo(ManageCustomer)
